import React from 'react'
import styles from './DragAndDrop.module.scss'
import sampleTemplate from '../../../assets/sample_image.png'
import sampleLogo from '../../../assets/school_logo.png'
import sampleQrCode from '../../../assets/qr_code.png'

// Sample values for live preview - shows realistic content instead of field labels
const SAMPLE_VALUES = {
  // Student information
  'Student Name': 'John Smith',
  'First Name': 'John',
  'Last Name': 'Smith',
  'Grade': '5th Grade',
  'Teacher': 'Mrs. Johnson',
  'Teacher Name': 'Mrs. Johnson',
  'Homeroom': 'Room 204',
  'Homeroom Teacher': 'Mrs. Johnson',

  // School information
  'School Name': 'Lincoln Elementary',
  'School': 'Lincoln Elementary',
  'School Year': '2025-2026',
  'Year': '2025-2026',

  // IDs and codes
  'Barcode': '123456789',
  'Student ID': '12345',
  'Student Number': '12345',
  'Access Code': 'ABC123',
  'ID Number': '12345',

  // Dates
  'Date': 'January 15, 2026',
  'Photo Date': 'January 15, 2026',

  // Award-specific fields
  'Award Title': 'Excellence Award',
  'Award Name': 'Excellence Award',
  'Awarded For': 'Outstanding Achievement',
  'Award Date': 'January 15, 2026',
  'Time Period': '2025-2026 School Year',
  'Definition': 'Demonstrates exceptional dedication and performance',
  'Trait Definition': 'Leadership, dedication, and academic excellence',

  // Spirit Week / Days
  'Day 1': 'Pajama Day',
  'Day 2': 'Crazy Hair Day',
  'Day 3': 'Twin Day',
  'Day 4': 'Sports Day',
  'Day 5': 'School Spirit Day',
  'Monday': 'Pajama Day',
  'Tuesday': 'Crazy Hair Day',
  'Wednesday': 'Twin Day',
  'Thursday': 'Sports Day',
  'Friday': 'School Spirit Day',
  'Theme': 'Spirit Week 2026',

  // Contact information
  'Phone': '(555) 123-4567',
  'Email': 'parent@email.com',
  'Address': '123 Main Street',

  // Yearbook fields
  'Quote': 'Dream big, work hard!',
  'Activity': 'Student Council, Drama Club',
  'Activities': 'Student Council, Drama Club',
  'Club': 'Art Club',
  'Sport': 'Basketball',
  'Sports': 'Basketball, Soccer',

  // Generic text fields
  'Title': 'Sample Title',
  'Subtitle': 'Sample Subtitle',
  'Text': 'Sample text content',
  'Description': 'A brief description here',
  'Note': 'Additional notes',
  'Notes': 'Additional notes',
}

export default function Box({ title, yellow, preview, align, textSize, font, sampleText, personalizationBoxUrl, text, columnType, hideBoundingBoxes }) {
  const backgroundColor = hideBoundingBoxes ? 'transparent' : (yellow ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.3)')

  const renderPreview = (title) => {
    // For static text fields, show the actual text content
    if (columnType === 'static_text' && text) {
      return <>{text}</>
    }
    // Handle image fields
    if (title.includes('Image') || title.includes('Picture') || title.includes('Pose')) {
      return (
        <div className={styles.poseContainer}>
          <p className={styles.poseNumber}>{title}</p>
          <img src={sampleTemplate} className={styles.sampleImage} />
        </div>
      )
    }

    // Handle logo fields
    if (title.includes('Logo')) {
      return <img src={sampleLogo} className={styles.sampleImage} />
    }

    // Handle QR code fields
    if (title.includes('QR')) {
      return <img src={sampleQrCode} className={styles.sampleImage} />
    }

    // Handle personalization box
    if (personalizationBoxUrl && !personalizationBoxUrl?.includes('missing')) {
      return <img src={personalizationBoxUrl} className={styles.sampleImage} />
    }

    // Priority order for text display:
    // 1. Use sampleText if provided (user-customized sample)
    // 2. Use SAMPLE_VALUES lookup if available
    // 3. Fall back to field label/title

    if (sampleText && sampleText.trim() !== '') {
      return <>{sampleText}</>
    }

    // Look for exact match first
    if (SAMPLE_VALUES[title]) {
      return <>{SAMPLE_VALUES[title]}</>
    }

    // Try partial matching for common patterns
    for (const [key, value] of Object.entries(SAMPLE_VALUES)) {
      if (title.toLowerCase().includes(key.toLowerCase()) ||
          key.toLowerCase().includes(title.toLowerCase())) {
        return <>{value}</>
      }
    }

    // Fall back to title
    return <>{title}</>
  }

  return (
    <div
      className={`${styles.box} ${!title.includes('Image') && styles.content}`}
      style={{
        backgroundColor,
        justifyContent: align,
        textAlign: align,
        fontSize: `${textSize}px`,
        fontFamily: font,
        border: hideBoundingBoxes ? 'none' : undefined
      }}
      role={preview ? 'BoxPreview' : 'Box'}
    >
      {renderPreview(title)}
    </div>
  )
}
